(() => {
  if (customElements.get('pw-welcome-popup')) return;
  const KEY = 'pw:welcome:v1';
  const COOKIE = 'pw_welcome_v1';
  const cookieGet = () => { try { return document.cookie.split('; ').some((c) => c.startsWith(COOKIE + '=')); } catch (e) { return false; } };
  const seen = () => {
    try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
    return cookieGet();
  };
  const remember = (v) => {
    try { localStorage.setItem(KEY, v); } catch (e) {}
    try { document.cookie = COOKIE + '=1; Max-Age=' + 60 * 60 * 24 * 60 + '; Path=/; SameSite=Lax'; } catch (e) {}
  };
  const blocked = () => {
    if (document.hidden) return true;
    const a = document.activeElement;
    if (a && a.matches && a.matches('input,textarea,select,[contenteditable="true"]')) return true;
    const list = document.querySelectorAll('dialog[open]:not(.pw-welcome), [aria-modal="true"], .edvi-bag-dialog[open], #shopify-pc__banner, #shopify-pc__prefs');
    return Array.from(list).some((el) => {
      const s = getComputedStyle(el);
      const r = el.getBoundingClientRect();
      return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
    });
  };

  class PWWelcomePopup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || seen()) return;
      this.form = this.querySelector('form');
      this.errorEl = this.querySelector('[data-pw-welcome-error]');
      this.querySelectorAll('[data-pw-welcome-close]').forEach((b) => b.addEventListener('click', () => this.close('dismissed')));
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close('dismissed'); });
      this.dialog.addEventListener('click', (e) => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close('dismissed');
      });
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.start = Date.now();
      this.timer = setTimeout(() => this.arm(), Number(this.dataset.delay) || 8000);
      if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
        this.exit = (e) => { if (e.clientY <= 0 && Date.now() - this.start > 4000) this.arm(); };
        document.addEventListener('mouseout', this.exit);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.retry); if (this.exit) document.removeEventListener('mouseout', this.exit); }
    arm() {
      if (this.shown || seen()) return;
      this.tries = (this.tries || 0) + 1;
      if (blocked()) { if (this.tries < 60) { clearTimeout(this.retry); this.retry = setTimeout(() => this.arm(), 2000); } return; }
      this.shown = true;
      clearTimeout(this.timer);
      if (this.exit) document.removeEventListener('mouseout', this.exit);
      this.returnFocus = document.activeElement;
      try { this.dialog.showModal(); } catch (e) { return; }
      remember('shown');
      const t = this.querySelector('#pw-welcome-title');
      t && t.focus({ preventScroll: true });
    }
    close(reason) {
      if (!this.dialog.open) return;
      remember(reason);
      this.dialog.close();
      const f = this.returnFocus;
      f && f.isConnected && f.focus && f.focus({ preventScroll: true });
    }
    step(name) {
      this.querySelectorAll('[data-pw-welcome-step]').forEach((el) => { el.hidden = el.dataset.pwWelcomeStep !== name; });
      this.dialog.dataset.step = name;
      const t = this.querySelector('[data-pw-welcome-step="' + name + '"] .pw-welcome__title');
      t && t.focus({ preventScroll: true });
    }
    showError(msg) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
    async submit(e) {
      e.preventDefault();
      const input = this.form.querySelector('input[type=email]');
      const btn = this.form.querySelector('button[type=submit]');
      this.errorEl.hidden = true;
      if (!input.value || !/^\S+@\S+\.\S+$/.test(input.value.trim())) { this.showError('Please enter a valid email address.'); input.focus(); return; }
      btn.disabled = true;
      try {
        const res = await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (/\/challenge/.test(res.url)) { this.form.submit(); return; }
        if (!res.ok || /[?&]contact_posted=false/.test(res.url)) throw new Error('fail');
        remember('subscribed');
        this.step('done');
      } catch (err) {
        this.showError('Something went wrong. Please try again.');
        btn.disabled = false;
      }
    }
  }
  customElements.define('pw-welcome-popup', PWWelcomePopup);
})();
